import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FalkeTekLogo } from "../components/Brand";
import { api, formatApiErrorDetail } from "../lib/api";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      const msg = formatApiErrorDetail(err.response?.data?.detail)
        || (err.response?.status === 404 ? "Endpunkt nicht gefunden – bitte Backend neu deployen" : null)
        || (err.response?.status === 429 ? "Zu viele Versuche – bitte 15 Min. warten" : null)
        || (err.response?.status >= 500 ? "Server-Fehler – bitte später erneut versuchen" : null)
        || (!err.response ? "Keine Verbindung zum Server (CORS/Netzwerk?)" : null)
        || `Anfrage fehlgeschlagen (Code ${err.response?.status || "?"})`;
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-falke-warmwhite flex flex-col">
      <header className="px-6 py-5 bg-white border-b border-falke-blue/10">
        <FalkeTekLogo />
      </header>
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md falke-card p-6 sm:p-8" data-testid="forgot-password-card">
          <h2 className="text-2xl font-heading font-semibold text-falke-blue mb-2">Passwort vergessen?</h2>
          <p className="text-sm text-falke-anthracite/70 mb-6">
            Kein Problem. Gib deine E-Mail an, wir senden dir einen Link zum Zurücksetzen.
          </p>

          {!sent && (
            <form onSubmit={onSubmit} data-testid="forgot-password-form">
              <label className="block text-sm font-medium text-falke-blue mb-1.5">E-Mail</label>
              <input
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-falke-blue/15 focus:outline-none focus:ring-2 focus:ring-falke-orange/40 focus:border-falke-orange mb-2"
                placeholder="max@example.de"
              />
              {error && <div className="text-sm text-red-600 my-3" data-testid="forgot-error">{error}</div>}
              <button type="submit" disabled={loading} className="btn-primary w-full mt-4" data-testid="forgot-submit">
                {loading ? "Wird gesendet..." : "Reset-Link senden"}
              </button>
            </form>
          )}

          {sent && (
            <div className="text-center py-4" data-testid="forgot-sent">
              <CheckCircle2 className="mx-auto text-falke-orange mb-3" size={42} />
              <h3 className="font-heading text-lg text-falke-blue mb-2">E-Mail unterwegs</h3>
              <p className="text-sm text-falke-anthracite/70 mb-5">
                Falls ein Konto mit <span className="font-semibold text-falke-blue">{email}</span> existiert,
                findest du einen Link zum Zurücksetzen in deinem Postfach (bitte auch Spam prüfen).
                Der Link ist 60 Minuten gültig.
              </p>
            </div>
          )}

          <div className="mt-6 text-center text-sm text-falke-anthracite/70">
            <Link to="/login" className="text-falke-orange font-semibold hover:underline" data-testid="link-back-login">
              Zurück zum Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
